@layer module {
.input-amount-wrapper {
            display: flex;
            flex-flow: column nowrap;
            align-items: flex-start;
            width: 100%;
    }

.input-amount-element {
            width: 100%;
            border: none;
            border-bottom-width: 1px;
            border-bottom-style: solid;
            outline: none;
    }

.input-amount-static {
            width: 100%;
            border-bottom-width: 1px;
            border-bottom-style: solid;
            display: flex;
            align-items: center;
    }
} // layer module










@layer app {
.input-amount-error {
            margin-top: $size-10;
    }

.input-amount-element {
            height: $size-45;
    }

.input-amount-static {
            height: $size-45;
    }

.input-amount-error {
            color: var(--color-error);
            font-size: var(--font-size-sm);
            font-style: italic;
            font-weight: normal;
            line-height: $size-15;
    }

.input-amount-label {
            color: var(--banky-black);
            font-size: var(--font-size-lg);
            font-style: normal;
            font-weight: 400;
            line-height: $size-19;
    }

.input-amount-element {
            --input-placeholder-font-size: var(--font-size-xl);
            --input-placeholder-line-height: #{$size-29};
            border-bottom-color: var(--field-divider);
            font-size: var(--font-size-xl);
            font-style: normal;
            font-weight: 400;
            line-height: $size-29;
    }

.input-amount-static {
            border-bottom-color: var(--field-divider);
            font-size: var(--font-size-xl);
            font-style: normal;
            font-weight: 400;
            line-height: $size-29;
    }
} // layer app
